import { render, staticRenderFns } from "./projectDetail.vue?vue&type=template&id=feafdf10&"
import script from "./projectDetail.vue?vue&type=script&lang=js&"
export * from "./projectDetail.vue?vue&type=script&lang=js&"
import style0 from "./projectDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports